/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React, { useContext } from 'react';
import { useTranslation } from '@scuf/localization';
import descriptors from '../../../../locales/en-US/descriptors';
import {
  convertDataForCarbonDetailSavingsMeter,
  getCarbonTotalEmissionMeterDetails,
  getUtilityTypeMeterCarbonDetails
} from '../../../shared/Utils/CarbonViewDetailsUtils';
import {
  CarbonDetailExpandMeterField,
  UtilityType
} from '../../../shared/Utils/Constants';
import { IDataTableColumn } from '../../../shared/MeterSavingsDetailTable/IMeterSavingsDetailTableProps';
import { ICarbonData } from '../../../DashboardKPIWidgets/IEnergyManagementProps';
import DetailBreakdownByScope from '../../../shared/DetailBreakdownByScope/DetailBreakdownByScope';
import {
  convertDataForCarbonUtilityScopeOneSavingsMeter,
  flattenEmissionByScopeArray
} from '../../../shared/Utils/CarbonViewDetailsUtils';
import { ConversionType } from '../../../shared/Utils/unitHandling/UnitModel';
import { CarbonScopeDetailsField } from '../../../shared/Utils/Constants';
import { ApiContext } from '../../../../context/ApiContext';

interface ITotalEmissionsSavingsByMeterDetailComponentProps {
  data: ICarbonData;
}

export const TotalEmissionsSavingsByMeterDetailNewComponent: any = (
  props: ITotalEmissionsSavingsByMeterDetailComponentProps
) => {
  const [t] = useTranslation();
  const d = descriptors.DetailedView;
  const apiContext = useContext(ApiContext);
  const { data } = props;
  const {
    emissionMeasurementUnit,
    emissionsByUtility,
    emissionsByScope
  } = data;

  const flattenedEmissionBySubScope = flattenEmissionByScopeArray(
    emissionsByScope && emissionsByScope.length && emissionsByScope
      ? [...emissionsByScope]
      : [],
    []
  );

  const progressBarRelativeWidth:
    | number
    | null
    | undefined = convertDataForCarbonUtilityScopeOneSavingsMeter(
    emissionMeasurementUnit,
    ConversionType.CARBON,
    JSON.parse(JSON.stringify(flattenedEmissionBySubScope))
  ).values[0].progessBarRelativeWidth;

  const meterSavingdata = convertDataForCarbonUtilityScopeOneSavingsMeter(
    emissionMeasurementUnit,
    ConversionType.CARBON,
    emissionsByScope,
    flattenedEmissionBySubScope,
    apiContext.showChangeWhenData
  );

  const { values, displayUnit } = meterSavingdata;

  const subUtilityMeasurementUnit =
    meterSavingdata.values[0].emissionsBySubScope?.displayUnit;

  const subUtilitycolumnDetails: Array<IDataTableColumn> = [
    {
      className: 'datatable-column-meter',
      field: CarbonScopeDetailsField.combustionType,
      header: t(d.Emissions),
      sortable: true,
      initialWidth: '10%'
    },
    {
      className: 'datatable-column-actualConsumption',
      field: CarbonScopeDetailsField.actualConsumption,
      header: t(d.ACTUALEMISSION),
      sortable: true,
      initialWidth: '20%'
    },
    {
      className: 'datatable-column-baselineConsumption',
      field: CarbonScopeDetailsField.baselineConsumption,
      header: t(d.PREVIOUSEMISSION),
      sortable: true,
      initialWidth: '13%'
    },
    {
      className: 'datatable-column-change',
      field: CarbonScopeDetailsField.change,
      header: t(d.CHANGE),
      sortable: true,
      initialWidth: '7%'
    }
  ];

  const columnDetails: Array<IDataTableColumn> = [
    {
      className: 'datatable-column-meter',
      field: CarbonScopeDetailsField.scope,
      header: t(d.Emissions),
      sortable: true,
      initialWidth: '10%'
    },
    {
      className: 'datatable-column-actualConsumption',
      field: CarbonScopeDetailsField.actualConsumption,
      header: t(d.ACTUALEMISSION),
      sortable: true,
      initialWidth: '20%'
    },
    {
      className: 'datatable-column-baselineConsumption',
      field: CarbonScopeDetailsField.baselineConsumption,
      header: t(d.PREVIOUSEMISSION),
      sortable: true,
      initialWidth: '13%'
    },
    {
      className: 'datatable-column-change',
      field: CarbonScopeDetailsField.change,
      header: t(d.CHANGE),
      sortable: true,
      initialWidth: '7%'
    }
  ];

  return (
    <div className="emaas-Metersaving-details-head">
      <DetailBreakdownByScope
        subUtilityMeasurementUnit={displayUnit}
        meterData={values}
        utilityMeasurementUnit={displayUnit}
        columnDetails={columnDetails}
        // utilityType={UtilityBillType}
        subUtilitycolumnDetails={subUtilitycolumnDetails}
        progressBarRelativeWidth={
          progressBarRelativeWidth ? progressBarRelativeWidth : 0
        }
        emissionMeasurementUnit={emissionMeasurementUnit}
      />
    </div>
  );
};
export default TotalEmissionsSavingsByMeterDetailNewComponent;
